/**
 * MySpace – SVG icon.
 */
import Colors from '@shared/assets/style/default/color';
import Props from '@shared/types/props/pressable';
import Screen from '@screen';

/** My space menu icon. */
export default function MySpaceIcon({ focused, height, width }: Props) {
  const color = Colors['menu']['icon'][focused ? 'focused' : 'unfocused'];
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={`${width || 24 * Screen.widthRatio}`}
      height={`${height || 24 * Screen.widthRatio}`}
      viewBox={'0 0 24 24'}
      fill='none'
    >
      <path
        d='M19.3906 11.0342H15.4282C13.4568 11.0342 12.5054 10.1612 12.5054 8.35655V3.90368C12.5054 2.09899 13.4666 1.22607 15.4282 1.22607H19.3906C21.3621 1.22607 22.3134 2.09899 22.3134 3.90368V8.34674C22.3134 10.1612 21.3523 11.0342 19.3906 11.0342ZM15.4282 2.69729C14.1139 2.69729 13.9766 3.06999 13.9766 3.90368V8.34674C13.9766 9.19023 14.1139 9.55313 15.4282 9.55313H19.3906C20.7049 9.55313 20.8422 9.18043 20.8422 8.34674V3.90368C20.8422 3.06018 20.7049 2.69729 19.3906 2.69729H15.4282Z'
        fill={color}
        stroke={color}
        strokeWidth={focused ? 0.8 : 0.5}
        strokeLinejoin='round'
        strokeLinecap='round'
      />
      <path
        d='M19.3906 22.3134H15.4282C13.4568 22.3134 12.5054 21.3523 12.5054 19.3906V15.4282C12.5054 13.4568 13.4666 12.5054 15.4282 12.5054H19.3906C21.3621 12.5054 22.3134 13.4666 22.3134 15.4282V19.3906C22.3134 21.3523 21.3523 22.3134 19.3906 22.3134ZM15.4282 13.9766C14.2708 13.9766 13.9766 14.2708 13.9766 15.4282V19.3906C13.9766 20.548 14.2708 20.8422 15.4282 20.8422H19.3906C20.548 20.8422 20.8422 20.548 20.8422 19.3906V15.4282C20.8422 14.2708 20.548 13.9766 19.3906 13.9766H15.4282Z'
        fill={color}
        stroke={color}
        strokeWidth={focused ? 0.8 : 0.5}
        strokeLinejoin='round'
        strokeLinecap='round'
      />
      <path
        d='M8.11135 11.0342H4.14888C2.17746 11.0342 1.22607 10.1612 1.22607 8.35655V3.90368C1.22607 2.09899 2.18727 1.22607 4.14888 1.22607H8.11135C10.0828 1.22607 11.0342 2.09899 11.0342 3.90368V8.34674C11.0342 10.1612 10.073 11.0342 8.11135 11.0342ZM4.14888 2.69729C2.8346 2.69729 2.69729 3.06999 2.69729 3.90368V8.34674C2.69729 9.19023 2.8346 9.55313 4.14888 9.55313H8.11135C9.42563 9.55313 9.56294 9.18043 9.56294 8.34674V3.90368C9.56294 3.06018 9.42563 2.69729 8.11135 2.69729H4.14888Z'
        fill={color}
        stroke={color}
        strokeWidth={focused ? 0.8 : 0.5}
        strokeLinejoin='round'
        strokeLinecap='round'
      />
      <path
        d='M8.11135 22.3134H4.14888C2.17746 22.3134 1.22607 21.3523 1.22607 19.3906V15.4282C1.22607 13.4568 2.18727 12.5054 4.14888 12.5054H8.11135C10.0828 12.5054 11.0342 13.4666 11.0342 15.4282V19.3906C11.0342 21.3523 10.073 22.3134 8.11135 22.3134ZM4.14888 13.9766C2.99153 13.9766 2.69729 14.2708 2.69729 15.4282V19.3906C2.69729 20.548 2.99153 20.8422 4.14888 20.8422H8.11135C9.2687 20.8422 9.56294 20.548 9.56294 19.3906V15.4282C9.56294 14.2708 9.2687 13.9766 8.11135 13.9766H4.14888Z'
        fill={color}
        stroke={color}
        strokeWidth={focused ? 0.8 : 0.5}
        strokeLinejoin='round'
        strokeLinecap='round'
      />
    </svg>
  );
}
